import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: '/welcome', pathMatch: 'full' },
  {
    path: 'content/support',
    loadComponent: () => import('@thehubz/client/help-faq').then((m) => m.ClientHelpFaqComponent),
  },
  {
    path: 'content/:param',
    loadComponent: () => import('../lib/content/content.component').then((m) => m.ContentComponent),
  },
];

/**
 *  This class contain the main routing of application
 *
 * @export
 * @class AppRoutingModule
 */
@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
